<breadcrumb></breadcrumb>
<div class="content-box">
  <div class="col-sm-12">
    <div class="element-wrapper">
      <h6 class="element-header">Integration - Reservierungs-System</h6>
    </div>
  </div>
  <mat-tab-group animationDuration="0ms">
    <mat-tab [label]="'reservationIntegration.tabs.websiteIntegration' | translate">
      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">Wählen Sie Ihre gewünschte Integration aus</h5>
              <div class="form-desc">
                Ob als Button auf Ihrer Facebook Seite oder als Widget auf Ihrer Homepage. Mit der gastro.digital
                Reservierungsintegration können Sie überall Reservierungen anbieten.
              </div>

              <mat-accordion class="integration-expandable">
                <mat-expansion-panel (afterExpand)="expandPanel('link')">
                  <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
                    <!-- <i class="icon icon-facebook"></i> -->
                    <i class="icon icon-code"></i>
                    <div>
                      <mat-panel-title>
                        Direkter Link
                      </mat-panel-title>
                      <mat-panel-description>
                        Setze einen Link zur Online-Reservierung auf der deiner Webseite, Facebook oder Instagram
                      </mat-panel-description>
                    </div>
                  </mat-expansion-panel-header>
                  <div>
                    <!-- Gehen Sie auf Ihre Facebook Seite und klicken Sie dort auf die blaue Schaltfläche "Button hinzufügen".
                    Wählen Sie die Kategorie "Services buchen" und dann den Eintrag "Jetzt buchen". Fügen Sie dann in das
                    Textfeld folgenden Link ein: -->
                    <code>
                      https://reservierung.gastroguide.de/{{
                        activeClient?.name | specialCharacters: true | encodeURI
                      }}/{{ activeClient?.id }}

                      <a
                        class="btn btn-light"
                        style="padding: 0"
                        href="https://reservierung.gastroguide.de/{{
                          activeClient?.name | specialCharacters: true | encodeURI
                        }}/{{ activeClient?.id }}"
                        target="_blank"
                      >
                        <mat-icon style="font-size: 18px;line-height: 22px;">launch</mat-icon>
                      </a>
                    </code>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (afterExpand)="expandPanel('widget')">
                  <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
                    <i class="icon icon-code"></i>
                    <div>
                      <mat-panel-title>
                        Reservierungs-Widget
                      </mat-panel-title>
                      <mat-panel-description>
                        Binden Sie das Reservierungssystem direkt auf Ihre eigene Webseite ein
                      </mat-panel-description>
                    </div>
                  </mat-expansion-panel-header>
                  <div>
                    1. Binden Sie zunächst folgende Scripte an eine beliebige Stelle in Ihre Webseite ein:
                    <br /><b
                      >Wenn Sie mehrere Gastro.Digital Widgets auf Ihrer Webseite einbinden möchten, benötigen Sie
                      diesen Schritt nur 1x!</b
                    >
                    <code>
                      &#x3C;link rel=&#x22;stylesheet&#x22; href=&#x22;{{ frontendUrl }}/widgets/styles.css&#x22;
                      /&#x3E;
                      <br />
                      &#x3C;script src=&#x22;{{ frontendUrl }}/widgets/elements.js&#x22;&#x3E;&#x3C;/script&#x3E;
                    </code>
                    <br />
                    2. Fügen Sie an die Stelle, an der Sie das Reservierungs-Widget anzeigen möchten, folgendes HTML
                    ein:
                    <code>
                      &#x3C;reservation-widget client=&#x22;{{
                        activeClient?.id
                      }}&#x22;&#x3E;&#x3C;/reservation-widget&#x3E;
                    </code>
                  </div>
                  <legend><span>Vorschau</span></legend>
                  <div class="widget-preview" *ngIf="activeClient && expandedPanel === 'widget'">
                    <app-reservation-widget
                      [attr.client]="activeClient ? activeClient.id : 0"
                      *axLazyElement="widgetUrl"
                    ></app-reservation-widget>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel (afterExpand)="expandPanel('button')">
                  <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
                    <i class="icon icon-code"></i>
                    <div>
                      <mat-panel-title>
                        Reservierungs-Button
                      </mat-panel-title>
                      <mat-panel-description>
                        Binden Sie das Reservierungssystem mit einem Button auf Ihre eigene Webseite ein
                      </mat-panel-description>
                    </div>
                  </mat-expansion-panel-header>
                  <div>
                    1. Binden Sie zunächst folgende Scripte an eine beliebige Stelle in Ihre Webseite ein:
                    <br /><b
                      >Wenn Sie mehrere Gastro.Digital Widgets auf Ihrer Webseite einbinden möchten, benötigen Sie
                      diesen Schritt nur 1x!</b
                    >
                    <code>
                      &#x3C;link rel=&#x22;stylesheet&#x22; href=&#x22;{{ frontendUrl }}/widgets/styles.css&#x22;
                      /&#x3E;
                      <br />
                      &#x3C;script src=&#x22;{{ frontendUrl }}/widgets/elements.js&#x22;&#x3E;&#x3C;/script&#x3E;
                    </code>
                    <br />
                    2. Fügen Sie an die Stelle, an der Sie das Reservierungs-Widget anzeigen möchten, folgendes HTML
                    ein:
                    <code>
                      &#x3C;reservation-button client=&#x22;{{
                        activeClient?.id
                      }}&#x22;&#x3E;&#x3C;/reservation-button&#x3E;
                    </code>
                  </div>
                  <legend><span>Vorschau</span></legend>
                  <div class="widget-preview" *ngIf="activeClient && expandedPanel === 'button'">
                    <reservation-button
                      [attr.client]="activeClient ? activeClient.id : 0"
                      *axLazyElement="widgetUrl"
                    ></reservation-button>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <h6 class="element-header">Reihenfolge Online Reservierung</h6>
            <div class="element-box">
              <div class="row">
                <div class="col-sm-12 col-md-6" style="padding-left: 0px;">
                  <div class="form-group toggle-div">
                    Datum bevorzugt &nbsp;
                    <mat-slide-toggle
                      style="vertical-align:bottom"
                      name="isActive"
                      [(ngModel)]="generalResSettings.showShiftFirstOnline"
                      (change)="saveResSettings()"
                    >
                    </mat-slide-toggle>
                    &nbsp; Vorlage bevorzugt
                  </div>
                </div>
                <div class="form-desc">
                  Datum bevorzugt : Personen, Datum, Reservierungsvorlage
                  <br />
                  Vorlage bevorzugt : Personen, Reservierungsvorlage, Datum (nur verfügbare Tage können ausgewählt
                  werden)
                </div>
              </div>
              <!-- <button class="btn btn-primary" (click)="saveResSettings()">
                          Einstellungen speichern
                        </button> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <h6 class="element-header">Öffnungszeiten</h6>
            <div class="element-box">
              <form [formGroup]="settingsFormGroup">
                <mat-slide-toggle
                  class="example-margin"
                  formControlName="showOpeningHours"
                  (change)="saveIntegrationStyles()"
                >
                  <b>Öffnungszeiten im Widget anzeigen</b>
                </mat-slide-toggle>
                <br />
                <small>
                  Wenn aktiviert, werden die Öffnungszeiten unter der Datumsauswahl im Widget angezeigt.
                </small>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <h6 class="element-header">Widget-Layout</h6>
            <div class="element-box">
              <div class="row">
                <div class="col-sm-8">
                  <form [formGroup]="settingsFormGroup">
                    <h5 class="form-header">Wählen Sie eine Hintergrundfarbe</h5>

                    <color-picker-wrapper
                      [(color)]="settingsFormGroup.value.backgroundColor"
                      (colorChange)="changeBgColor($event)"
                    ></color-picker-wrapper>

                    <div class="form-desc">
                      Die Hintergrundfarbe Ihres Widgets und der externen Gutscheinkauf Seite.
                    </div>

                    <!-- <p class="label-checkbox"><b>Transparenter Hintergrund</b></p> -->
                    <mat-checkbox
                      class="example-margin"
                      formControlName="formBackgroundColorCheckBox"
                      (change)="checkedHandler($event)"
                    >
                      <b>Transparenter Hintergrund</b>
                    </mat-checkbox>

                    <div class="form-desc"></div>

                    <h5 class="form-header">Wählen Sie die Hauptfarbe aus</h5>

                    <color-picker-wrapper
                      [(color)]="settingsFormGroup.value.mainColor"
                      (colorChange)="changeMainColor($event)"
                    ></color-picker-wrapper>

                    <div class="form-desc">
                      Die Hauptfarbe wird für Texte genutzt.
                    </div>

                    <h5 class="form-header">Wählen Sie die Akzentfarbe aus</h5>

                    <color-picker-wrapper
                      [(color)]="settingsFormGroup.value.primaryColor"
                      (colorChange)="changePrimaryColor($event)"
                    ></color-picker-wrapper>

                    <div class="form-desc">
                      Die Akzentfarbe wird für Buttons und Akzente genutzt.
                    </div>

                    <div class="font-wrapper">
                      <h5 class="form-header">Wählen Sie eine Schriftart für Titel</h5>

                      <div
                        class="font"
                        [(fontPicker)]="font"
                        [fpWidth]="'320px'"
                        [fpDialogDisplay]="'popup'"
                        [fpSizeSelect]="true"
                        [fpSearchText]="'Schriftart suchen...'"
                        [fpLoadingText]="'Schriftarten werden geladen...'"
                        [fpPopularLabel]="'Beliebte Schriftarten'"
                        [fpResultsLabel]="'Suchergebnisse'"
                        [fpStyleSelect]="false"
                        [style.font-family]="settingsFormGroup.value.primaryFont"
                        (fontPickerChange)="changePrimaryFont($event)"
                      >
                        {{ settingsFormGroup.value.primaryFont }}
                      </div>

                      <div class="form-desc">
                        Die Schriftart wird für alle Titel und Buttons genutzt.
                      </div>
                    </div>

                    <div class="font-wrapper">
                      <h5 class="form-header">Wählen Sie eine Schriftart für Texte</h5>

                      <div
                        class="font"
                        [(fontPicker)]="secondaryFont"
                        [fpWidth]="'320px'"
                        [fpDialogDisplay]="'popup'"
                        [fpSizeSelect]="true"
                        [fpSearchText]="'Schriftart suchen...'"
                        [fpLoadingText]="'Schriftarten werden geladen...'"
                        [fpPopularLabel]="'Beliebte Schriftarten'"
                        [fpResultsLabel]="'Suchergebnisse'"
                        [fpStyleSelect]="false"
                        [style.font-family]="settingsFormGroup.value.secondaryFont"
                        (fontPickerChange)="changeSecondaryFont($event)"
                        #secondaryFontPicker
                      >
                        {{ settingsFormGroup.value.secondaryFont }}
                      </div>

                      <div class="form-desc">
                        Die Schriftart wird für alle Texte und Eingabefelder genutzt.
                      </div>
                    </div>

                    <button class="btn btn-primary" (click)="saveIntegrationStyles()">Einstellungen speichern</button>
                  </form>
                </div>
                <div class="col-sm-4" style="display: flex;">
                  <div class="preview-changes">
                    <ng-scrollbar [trackX]="false" [shown]="'hover'" [compact]="true">
                      <app-reservation
                        [client]="activeClient ? activeClient.id : 0"
                        [settings]="settingsFormGroup.value"
                      ></app-reservation>
                    </ng-scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="'reservationIntegration.tabs.pmsIntegration' | translate">
      <app-pms-integration></app-pms-integration>
    </mat-tab>
    <mat-tab *ngIf="hasWidgetPermission" [label]="'reservationIntegration.tabs.newWidgetIntegration' | translate">
      <app-web-theme-customizer></app-web-theme-customizer>
    </mat-tab>
    <mat-tab [label]="'IntegrationCode.TabLabel' | translate">
      <ng-template matTabContent>
        <div class="row">
          <div class="col-sm-12">
            <div class="element-wrapper">
              <div class="element-box">
                <div class="row">
                  <div class="col-sm-7">
                    <h5 class="form-header">{{ 'IntegrationCode.Heading' | translate }}</h5>
                    <div class="form-desc">
                      {{ 'IntegrationCode.ConfigDesc' | translate }}
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.Theme' | translate }}</label>
                      <ng-select
                        [items]="themeOptions"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        name="theme"
                        [(ngModel)]="widgetConfig.theme"
                        (change)="applyPreviewConfig()"
                      ></ng-select>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.Language' | translate }}</label>
                      <ng-select
                        [items]="localeOptions"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        name="locale"
                        [(ngModel)]="widgetConfig.locale"
                        (change)="applyPreviewConfig()"
                      ></ng-select>
                      <div class="form-desc">
                        {{ 'IntegrationCode.LanguageHint' | translate }}
                      </div>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.ButtonPosition' | translate }}</label>
                      <ng-select
                        [items]="fabPositionOptions"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        name="fabPosition"
                        [(ngModel)]="widgetConfig.fabPosition"
                        (change)="onFabChange()"
                      >
                        <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
                        <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
                      </ng-select>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.ButtonShape' | translate }}</label>
                      <ng-select
                        [items]="fabShapeOptions"
                        bindLabel="label"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        name="fabShape"
                        [(ngModel)]="widgetConfig.fabShape"
                        (change)="onFabChange()"
                      ></ng-select>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.FabLabel' | translate }}</label>
                      <input
                        type="text"
                        class="form-control"
                        name="fabLabel"
                        [(ngModel)]="widgetConfig.fabLabel"
                        (ngModelChange)="onFabChange()"
                      />
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.FabBgColor' | translate }}</label>
                      <mat-checkbox [(ngModel)]="useFabBgColor" name="useFabBgColor" (change)="onFabChange()">
                        {{ 'IntegrationCode.FabBgColorCustom' | translate }}
                      </mat-checkbox>
                      <color-picker-wrapper
                        *ngIf="useFabBgColor"
                        [color]="widgetConfig.fabBgColor"
                        (colorChange)="widgetConfig.fabBgColor = $event; onFabChange()"
                      ></color-picker-wrapper>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.AccentColor' | translate }}</label>
                      <color-picker-wrapper
                        [color]="widgetConfig.accentColor"
                        (colorChange)="widgetConfig.accentColor = $event; applyPreviewConfig()"
                      ></color-picker-wrapper>
                      <div class="form-desc">{{ 'IntegrationCode.AccentColorHint' | translate }}</div>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.PrimaryColor' | translate }}</label>
                      <color-picker-wrapper
                        [color]="widgetConfig.primaryColor"
                        (colorChange)="widgetConfig.primaryColor = $event; applyPreviewConfig()"
                      ></color-picker-wrapper>
                      <div class="form-desc">{{ 'IntegrationCode.PrimaryColorHint' | translate }}</div>
                    </div>

                    <button class="btn btn-primary" (click)="saveWidgetConfig()">
                      {{ 'IntegrationCode.SaveSettings' | translate }}
                    </button>

                    <legend>
                      <span>{{ 'IntegrationCode.YourCode' | translate }}</span>
                    </legend>

                    <div class="config-group config-group--wide">
                      <label>{{ 'IntegrationCode.EmbedType' | translate }}</label>
                      <div class="embed-cards">
                        <div class="embed-card" [class.active]="embedType === 'iife'" (click)="embedType = 'iife'">
                          <span class="embed-card__badge">A</span>
                          <div class="embed-card__body">
                            <div class="embed-card__title">{{ 'IntegrationCode.EmbedClassic' | translate }}</div>
                            <div class="embed-card__desc">{{ 'IntegrationCode.EmbedClassicHint' | translate }}</div>
                          </div>
                          <mat-icon class="embed-card__check">check_circle</mat-icon>
                        </div>
                        <div class="embed-card" [class.active]="embedType === 'esm'" (click)="embedType = 'esm'">
                          <span class="embed-card__badge">B</span>
                          <div class="embed-card__body">
                            <div class="embed-card__title">{{ 'IntegrationCode.EmbedModern' | translate }}</div>
                            <div class="embed-card__desc">{{ 'IntegrationCode.EmbedModernHint' | translate }}</div>
                          </div>
                          <mat-icon class="embed-card__check">check_circle</mat-icon>
                        </div>
                      </div>
                    </div>

                    <div class="config-group">
                      <label>{{ 'IntegrationCode.TriggerMode' | translate }}</label>
                      <ng-select
                        [items]="triggerModeOptions"
                        bindValue="value"
                        [searchable]="false"
                        [clearable]="false"
                        name="triggerMode"
                        [(ngModel)]="triggerMode"
                      >
                        <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
                        <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
                      </ng-select>
                      <div class="form-desc">{{ 'IntegrationCode.TriggerModeHint' | translate }}</div>
                    </div>

                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">HTML</span>
                        <button type="button" class="code-card__copy" (click)="copyIntegrationCode()">
                          <mat-icon>content_copy</mat-icon>
                          {{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ integrationCode }}</pre>
                    </div>
                  </div>

                  <div class="col-sm-5">
                    <legend>
                      <span>{{ 'IntegrationCode.Preview' | translate }}</span>
                    </legend>
                    <div class="widget-preview" *ngIf="activeClient">
                      <iframe
                        #previewFrame
                        class="preview-frame"
                        [srcdoc]="previewSrcdoc"
                        [style.height.px]="previewHeight"
                        (load)="onPreviewLoad()"
                        [title]="'IntegrationCode.PreviewTitle' | translate"
                      ></iframe>
                    </div>
                  </div>
                </div>
                <br />
                <mat-accordion class="integration-expandable dev-reference">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [collapsedHeight]="'72px'" [expandedHeight]="'72px'">
                      <mat-panel-title>
                        <span class="dev-ref-head">
                          <span class="dev-ref-head__icon">
                            <mat-icon>code</mat-icon>
                          </span>
                          <span class="dev-ref-head__text">
                            <span class="dev-ref-head__title">{{ 'IntegrationCode.DevRefTitle' | translate }}</span>
                            <span class="dev-ref-head__sub">{{ 'IntegrationCode.DevRefSubtitle' | translate }}</span>
                          </span>
                        </span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <h6 class="ref-heading">{{ 'IntegrationCode.RefEmbeddingOptions' | translate }}</h6>
                    <p class="ref-sub">{{ 'IntegrationCode.RefOptionA' | translate }}</p>
                    <div class="ref-desc">{{ 'IntegrationCode.EmbedClassicHint' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">HTML</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refEmbedClassic)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refEmbedClassic }}</pre>
                    </div>
                    <p class="ref-sub">{{ 'IntegrationCode.RefOptionB' | translate }}</p>
                    <div class="ref-desc">{{ 'IntegrationCode.EmbedModernHint' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">HTML</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refEmbedModern)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refEmbedModern }}</pre>
                    </div>

                    <h6 class="ref-heading">{{ 'IntegrationCode.RefProgrammatic' | translate }}</h6>
                    <div class="ref-desc">{{ 'IntegrationCode.RefProgrammaticDesc' | translate }}</div>
                    <p class="ref-sub">{{ 'IntegrationCode.RefImperative' | translate }}</p>
                    <div class="ref-desc">{{ 'IntegrationCode.RefImperativeDesc' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">JS</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refImperative)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refImperative }}</pre>
                    </div>
                    <p class="ref-sub">{{ 'IntegrationCode.RefDeclarative' | translate }}</p>
                    <div class="ref-desc">{{ 'IntegrationCode.RefDeclarativeDesc' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">JS</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refDeclarative)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refDeclarative }}</pre>
                    </div>
                    <p class="ref-sub">{{ 'IntegrationCode.RefExample' | translate }}</p>
                    <div class="ref-desc">{{ 'IntegrationCode.RefExampleDesc' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">HTML</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refExampleButton)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refExampleButton }}</pre>
                    </div>

                    <h6 class="ref-heading">{{ 'IntegrationCode.RefTheming' | translate }}</h6>
                    <div class="ref-desc">{{ 'IntegrationCode.RefThemingDesc' | translate }}</div>
                    <div class="code-card">
                      <div class="code-card__bar">
                        <span class="code-card__label">CSS</span>
                        <button type="button" class="code-card__copy" (click)="copyText(refTheming)">
                          <mat-icon>content_copy</mat-icon>{{ 'IntegrationCode.CopyCode' | translate }}
                        </button>
                      </div>
                      <pre class="integration-code-block code-card__body">{{ refTheming }}</pre>
                    </div>
                    <div class="ref-desc">{{ 'IntegrationCode.RefThemingNote' | translate }}</div>

                    <h6 class="ref-heading">{{ 'IntegrationCode.RefQuickReference' | translate }}</h6>
                    <table class="quick-ref-table">
                      <tr>
                        <td>{{ 'IntegrationCode.QrClassic' | translate }}</td>
                        <td>
                          <div class="qr-code">
                            <code>{{ qrCodeClassic }}</code>
                            <button
                              type="button"
                              class="qr-copy"
                              (click)="copyText(qrCodeClassic)"
                              [title]="'IntegrationCode.CopyCode' | translate"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'IntegrationCode.QrModern' | translate }}</td>
                        <td>
                          <div class="qr-code">
                            <code>{{ qrCodeModern }}</code>
                            <button
                              type="button"
                              class="qr-copy"
                              (click)="copyText(qrCodeModern)"
                              [title]="'IntegrationCode.CopyCode' | translate"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'IntegrationCode.QrOpenRef' | translate }}</td>
                        <td>
                          <div class="qr-code">
                            <code>{{ qrCodeOpenRef }}</code>
                            <button
                              type="button"
                              class="qr-copy"
                              (click)="copyText(qrCodeOpenRef)"
                              [title]="'IntegrationCode.CopyCode' | translate"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'IntegrationCode.QrOpenEvent' | translate }}</td>
                        <td>
                          <div class="qr-code">
                            <code>{{ qrCodeOpenEvent }}</code>
                            <button
                              type="button"
                              class="qr-copy"
                              (click)="copyText(qrCodeOpenEvent)"
                              [title]="'IntegrationCode.CopyCode' | translate"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'IntegrationCode.QrRestyle' | translate }}</td>
                        <td>
                          <div class="qr-code">
                            <code>{{ qrCodeRestyle }}</code>
                            <button
                              type="button"
                              class="qr-copy"
                              (click)="copyText(qrCodeRestyle)"
                              [title]="'IntegrationCode.CopyCode' | translate"
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
